// The console's icons: the Console D mock's symbols (apsio-planning/design/console-d/index.html),
// 16 px on a 16 grid with a 1.5 stroke in the text's colour (base.css `svg.ic`). Inline, so they
// need no sprite and pass the CSP. Decoration: every icon is aria-hidden; the text beside it
// names the control.
import type { ReactNode } from 'react'

const PATHS = {
  home: (
    <>
      <path d="M2.5 7.5L8 3l5.5 4.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
      <path d="M6.5 13.5v-4h3v4" />
    </>
  ),
  issues: (
    <>
      <path d="M8 2.5l6 10.5H2z" />
      <path d="M8 6.5v3M8 11.5h0" />
    </>
  ),
  alerts: (
    <>
      <path d="M4 11V7a4 4 0 0 1 8 0v4l1 1.5H3z" />
      <path d="M6.5 14h3" />
    </>
  ),
  releases: (
    <>
      <path d="M2.5 2.5h5l6 6-5 5-6-6z" />
      <circle cx="5.5" cy="5.5" r="1" />
    </>
  ),
  perf: (
    <>
      <path d="M2.5 11.5a5.5 5.5 0 1 1 11 0" />
      <path d="M8 11.5l3-4" />
    </>
  ),
  sessions: (
    <>
      <ellipse cx="8" cy="8" rx="6" ry="4" transform="rotate(-20 8 8)" />
      <circle cx="11" cy="7" r="1.2" fill="currentColor" />
    </>
  ),
  journeys: (
    <>
      <circle cx="3.5" cy="4" r="1.5" />
      <circle cx="12.5" cy="12" r="1.5" />
      <path d="M5 4h4a2.5 2.5 0 0 1 0 5H7a2.5 2.5 0 0 0 0 5h4" />
    </>
  ),
  explore: (
    <>
      <path d="M3 4.5l3 3-3 3M8 11.5h5" />
    </>
  ),
  dash: (
    <>
      <rect x="2.5" y="2.5" width="4.5" height="5" rx="1" />
      <rect x="9" y="2.5" width="4.5" height="3" rx="1" />
      <rect x="2.5" y="9.5" width="4.5" height="4" rx="1" />
      <rect x="9" y="7.5" width="4.5" height="6" rx="1" />
    </>
  ),
  settings: (
    <>
      <path d="M6.9 1.8h2.2l.35 1.7 1.15.48 1.45-.96 1.56 1.56-.96 1.45.48 1.15 1.7.35v2.2l-1.7.35-.48 1.15.96 1.45-1.56 1.56-1.45-.96-1.15.48-.35 1.7H6.9l-.35-1.7-1.15-.48-1.45.96-1.56-1.56.96-1.45-.48-1.15-1.7-.35V6.9l1.7-.35.48-1.15-.96-1.45 1.56-1.56 1.45.96 1.15-.48z" />
      <circle cx="8" cy="8" r="2.1" />
    </>
  ),
  search: (
    <>
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5l3 3" />
    </>
  ),
  chev: (
    <>
      <path d="M4.5 6.5L8 10l3.5-3.5" />
    </>
  ),
  right: (
    <>
      <path d="M6.5 4.5L10 8l-3.5 3.5" />
    </>
  ),
  left: (
    <>
      <path d="M9.5 4.5L6 8l3.5 3.5" />
    </>
  ),
  agent: (
    <>
      <rect x="2.5" y="4" width="11" height="8.5" rx="2" />
      <path d="M8 2v2M6 8h0M10 8h0" />
    </>
  ),
  pr: (
    <>
      <circle cx="4" cy="4" r="1.5" />
      <circle cx="4" cy="12" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <path d="M4 5.5v5M12 10.5V7a2 2 0 0 0-2-2H7" />
      <path d="M8.5 3.5L7 5l1.5 1.5" />
    </>
  ),
  menu: (
    <>
      <path d="M2.5 4.5h11M2.5 8h11M2.5 11.5h11" />
    </>
  ),
  x: (
    <>
      <path d="M4.5 4.5l7 7M11.5 4.5l-7 7" />
    </>
  ),
  plus: (
    <>
      <path d="M8 3.5v9M3.5 8h9" />
    </>
  ),
  copy: (
    <>
      <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" />
      <path d="M10.5 5.5V3.5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2" />
    </>
  ),
  ext: (
    <>
      <path d="M9 2.5h4.5V7M13.5 2.5L7 9M11.5 9.5v3a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3" />
    </>
  ),
  check: (
    <>
      <path d="M3 8.5l3 3 7-7" />
    </>
  ),
  slack: (
    <>
      <path d="M6 2.5v6M10 7.5v6M2.5 10h6M7.5 6h6" />
    </>
  ),
  play: (
    <>
      <path d="M5 3.5v9l7.5-4.5z" />
    </>
  ),
  pause: (
    <>
      <path d="M5.5 3.5v9M10.5 3.5v9" />
    </>
  ),
  bolt: (
    <>
      <path d="M9 1.5L3.5 9H8l-1 5.5L12.5 7H8z" />
    </>
  ),
  // An email destination (APS-477): an envelope on the same grid and stroke.
  mail: (
    <>
      <rect x="2" y="3.5" width="12" height="9" rx="1" />
      <path d="M2.5 4.5L8 8.5l5.5-4" />
    </>
  ),
  git: (
    <>
      <circle cx="5" cy="4" r="1.5" />
      <circle cx="5" cy="12" r="1.5" />
      <circle cx="11" cy="8" r="1.5" />
      <path d="M5 5.5v5M6.5 4.5c2.5 0 3 1.5 3 2" />
    </>
  ),
  updown: (
    <>
      <path d="M5 6l3-3 3 3M5 10l3 3 3-3" />
    </>
  ),
  user: (
    <>
      <circle cx="8" cy="5.5" r="2.75" />
      <path d="M2.75 13.5c.6-2.6 2.7-4 5.25-4s4.65 1.4 5.25 4" />
    </>
  ),
  sliders: (
    <>
      <path d="M2.5 4.5h6M11.5 4.5h2M2.5 11.5h2M7.5 11.5h6" />
      <circle cx="10" cy="4.5" r="1.5" />
      <circle cx="6" cy="11.5" r="1.5" />
    </>
  ),
  kbd: (
    <>
      <rect x="1.5" y="4" width="13" height="8.5" rx="1.5" />
      <path d="M4.5 7h0M7 7h0M9.5 7h0M12 7h0M5 9.75h6" />
    </>
  ),
  book: (
    <>
      <path d="M8 4.5c-1.5-1.2-3.5-1.5-5.5-1.2v9c2-.3 4 0 5.5 1.2 1.5-1.2 3.5-1.5 5.5-1.2v-9c-2-.3-4 0-5.5 1.2zM8 4.5v9" />
    </>
  ),
  out: (
    <>
      <path d="M6.5 2.5h-3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3M10.5 11l3-3-3-3M13.5 8h-7" />
    </>
  ),
  org: (
    <>
      <rect x="3" y="2.5" width="10" height="11" rx="1" />
      <path d="M6 5.5h0M10 5.5h0M6 8h0M10 8h0M7 13.5v-2.5h2v2.5" />
    </>
  ),
  trace: (
    <>
      <path d="M2.5 3.5h7M4.5 6.5h8M6.5 9.5h5M4.5 12.5h3" />
    </>
  ),
  flag: (
    <>
      <path d="M3.5 14V2.5M3.5 3h8.5l-2 3 2 3H3.5" />
    </>
  ),
  key: (
    <>
      <circle cx="5.5" cy="10.5" r="3" />
      <path d="M7.6 8.4l5.4-5.4M11 5l1.75 1.75M9.5 6.5l1.25 1.25" />
    </>
  ),
  chip: (
    <>
      <rect x="4" y="4" width="8" height="8" rx="1.5" />
      <path d="M6.5 1.5v2.5M9.5 1.5v2.5M6.5 12v2.5M9.5 12v2.5M1.5 6.5H4M1.5 9.5H4M12 6.5h2.5M12 9.5h2.5" />
    </>
  ),
  file: (
    <>
      <path d="M4 1.75h5l3 3V14.25H4z" />
      <path d="M9 1.75v3h3M6.25 8.5h3.5M6.25 11h3.5" />
    </>
  ),
  stack: (
    <>
      <path d="M8 2l6 3-6 3-6-3z" />
      <path d="M2 8l6 3 6-3M2 11l6 3 6-3" />
    </>
  ),
  link: (
    <>
      <path d="M6.75 9.25a3 3 0 0 0 4.24 0l2.12-2.12a3 3 0 0 0-4.24-4.24l-.7.7" />
      <path d="M9.25 6.75a3 3 0 0 0-4.24 0L2.89 8.87a3 3 0 0 0 4.24 4.24l.7-.7" />
    </>
  ),
  card: (
    <>
      <rect x="1.75" y="3.5" width="12.5" height="9" rx="1.5" />
      <path d="M1.75 6.5h12.5M4.5 10h2.5" />
    </>
  ),
  history: (
    <>
      <path d="M2.5 8a5.5 5.5 0 1 0 1.6-3.9M2.5 2.5v2.75h2.75" />
      <path d="M8 5v3.25l2.25 1.5" />
    </>
  ),
  shield: (
    <>
      <path d="M8 1.75l5.25 2v4c0 3.2-2.3 5.4-5.25 6.5-2.95-1.1-5.25-3.3-5.25-6.5v-4z" />
      <path d="M5.75 8l1.5 1.5 3-3" />
    </>
  ),
  lock: (
    <>
      <rect x="3" y="7" width="10" height="7.25" rx="1.5" />
      <path d="M5.25 7V5a2.75 2.75 0 0 1 5.5 0v2" />
    </>
  ),
  sidebar: (
    <>
      <rect x="2" y="2.5" width="12" height="11" rx="2" />
      <path d="M6 2.5v11" />
    </>
  ),
  pulse: (
    <>
      <path d="M1.5 8.5h3l1.5-4 3 8 1.5-4h4" />
    </>
  ),
  toggle: (
    <>
      <rect x="1.5" y="4.5" width="13" height="7" rx="3.5" />
      <circle cx="11" cy="8" r="1.75" />
    </>
  ),
  people: (
    <>
      <circle cx="6" cy="5.5" r="2.25" />
      <path d="M1.75 13c.5-2.2 2.2-3.5 4.25-3.5s3.75 1.3 4.25 3.5" />
      <path d="M10.5 3.5a2.25 2.25 0 0 1 0 4.25M12 9.75c1.2.5 2 1.6 2.25 3.25" />
    </>
  ),
  logs: (
    <>
      <path d="M2.5 3.5h1M2.5 8h1M2.5 12.5h1M6 3.5h7.5M6 8h7.5M6 12.5h5" />
    </>
  ),
  // Not in the mock's sprite: Settings › Data export (APS-200, Mosaic), drawn on its grid.
  download: (
    <>
      <path d="M8 2.5v8M4.75 7.5L8 10.75l3.25-3.25M2.5 13.5h11" />
    </>
  ),
  capture: (
    <>
      <circle cx="8" cy="8" r="5.75" />
      <circle cx="8" cy="8" r="2.25" fill="currentColor" />
    </>
  ),
  pin: (
    <>
      <path d="M9.5 2.5l4 4-2 .75-2.5 2.5.25 2.75-1.25 1.25-2.5-2.5L2.5 14.5M5.5 8.75L3 6.25l1.25-1.25 2.75.25 2.5-2.5z" />
    </>
  ),
  plug: (
    <>
      <path d="M6 1.5v3M10 1.5v3M4 4.5h8v2.5a4 4 0 0 1-8 0zM8 11v3.5" />
    </>
  ),
} satisfies Record<string, ReactNode>

export type IconName = keyof typeof PATHS
export const ICON_NAMES = Object.keys(PATHS) as IconName[]

/** One of the mock's icons; `small` is the 12 px size (chevrons, the chip's ×). */
export function Icon({
  name,
  small,
  className,
}: {
  name: IconName
  small?: boolean
  className?: string
}) {
  return (
    <svg
      className={['ic', small ? 's' : '', className ?? ''].filter(Boolean).join(' ')}
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  )
}

// The older inline icons, still used by pages that are not on Console D yet.
const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

export function Chevron() {
  return (
    <svg viewBox="0 0 12 12" aria-hidden="true" width="12" height="12" style={{ flex: 'none' }}>
      <path d="M2.5 4.5l3.5 3.5 3.5-3.5" {...stroke} />
    </svg>
  )
}

export function Check({ size = 16 }: { size?: number }) {
  return (
    <svg viewBox="0 0 18 18" aria-hidden="true" width={size} height={size}>
      <path d="M3.5 9.5l3.5 3.5 7.5-8" {...stroke} strokeWidth={2} />
    </svg>
  )
}

export function MenuIcon() {
  return (
    <svg viewBox="0 0 18 18" aria-hidden="true" width="18" height="18">
      <path d="M3 5h12M3 9h12M3 13h12" {...stroke} />
    </svg>
  )
}
